import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../providers/AuthContext';
import type { JSX } from 'react';

interface RequireRoleProps {
    allowedRoles: string[];
    children: JSX.Element;
}

export const RequireRole = ({ allowedRoles, children }: RequireRoleProps) => {
    const { user, isAuthenticated } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!user || !allowedRoles.includes(user.role)) {
        return <Navigate to="/admin" replace />;
    }

    return children;
};
